import React from "react";
import { connect } from "react-redux";
import { DashboardHeader } from "../../../components/Header";
import language from "../../../language";
import Request from "../../../components/Wallet/request";

class RequestScreen extends React.Component {
  render() {
    return (
      <div className="card">
        <div className="card-body">
          <DashboardHeader
            title={language[this.props.defaultLanguage].requests}
            titleClassName="text-primary"
          />
          <Request />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(RequestScreen);
